<script>
import { mapState } from "vuex"
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'CadastroTelegram',
  props: { 
  },
  data () {
    return {
      isMobile: isMobile,
      idState: null,
    }
  },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      clientinfo: state => state.moduleLogin.clientinfo,
      idTelegram: state => state.moduleTelegram.idTelegram
    }),
    idTelegram: {
      get () {
        return this.$store.state.moduleTelegram.idTelegram
      },
      set (value) {
        this.$store.commit('UPDATEMESSAGE', value)
        this.idTelegram.length > 0 ? this.idState = null : this.idState = false
      }
    }
  },
  methods: {
    telegramClick(){
      if(this.idTelegram.length == 0) {
        this.idState = false
      }else {
        this.$store.dispatch("GRAVATELEGRAM", {codigoUsuario: this.usuario.codUsuario, codigoTelegram: this.idTelegram, cidade: this.user.cidade}).then((resolve) =>{
          if (resolve.toLowerCase().includes("gravado")){
            this.$swal.fire({
              title: "Telegram",
              text: resolve,
              icon: "success",
            })
          }else
            if (resolve.toLowerCase().includes("error")){
              this.$swal.fire({
                title: "Telegram",
                text: resolve,
                icon: "error",
              })
            }
        })
      }
    },
    testarClick() {
      if(this.idTelegram.length == 0) {
        this.idState = false
      } else {
        this.$store.dispatch("TESTETELEGRAM", {codigoTelegram: this.idTelegram}).then((resolve) => {
          if (resolve.ok){
            this.$swal.fire({
              title: "Telegram",
              text: "Mensagem Enviado com Sucesso",
              icon: "success",
            })
          }
          else {
            this.$swal.fire({
              title: "Telegram",
              text: "Mensagem não possivel ser entregue",
              icon: "error",
            })
          }
        }).catch(() => {
          this.$swal.fire({
            title: "Telegram",
            text: "Mensagem não possivel ser entregue. Verifique seu ID",
            icon: "error",
          })
        })
      }
      
    }
  },
  mounted (){
    this.$store.dispatch("BUSCATELEGRAM", {codigoUsuario: this.usuario.codUsuario, cidade: this.user.cidade})
  },
  watch: {
  }
}
</script>

<template>
  <b-container class="container">
    <b-row>
      <b-col cols=12 md="6">
        <div class="textoFiltros">Cadastro no Telegram</div>
        <b-row class="text-left" align-v="center">
          <b-col cols="6">
            <b-form-text>Numero do ID Telegram:</b-form-text>
            <b-form-input class="shadow rounded"  v-model="idTelegram" style="letter-spacing: 5px" maxLength=12 :state="idState"/>
            <b-form-invalid-feedback id="id-feedback">Preencha seu ID</b-form-invalid-feedback>
          </b-col>
          <b-col cols="6">
            <b-button class="button-submit float-right shadow rounded" variant="primary" @click="telegramClick">Cadastrar</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button-submit float-right shadow rounded" variant="success" @click="testarClick">Testar</b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols=12 md="6">
        <div class="textoFiltros">Instrução para o Cadastro no Telegram</div>
        <h6 class="text-left">1 - Click na lupa.</h6>
        <b-img class="shadow rounded" thumbnail v-viewer :src="require('@/assets/telegram/1.jpeg')" fluid alt="1" style="max-height: 5rem;"/>

        <h6 class="text-left">2 - Digite o nome do robo PAlerta.</h6>
        <b-img class="shadow rounded" thumbnail v-viewer :src="require('@/assets/telegram/2.jpeg')" fluid alt="2" style="max-height: 8rem;"/>

        <h6 class="text-left">3 - Acesse e click em começar.</h6>
        <b-img class="shadow rounded" thumbnail v-viewer :src="require('@/assets/telegram/3.jpeg')" fluid alt="3" style="max-height: 10rem;"/>

        <h6 class="text-left">4 - Click no Menu e /meu_id.</h6>
        <b-img class="shadow rounded" thumbnail v-viewer :src="require('@/assets/telegram/4.jpeg')" fluid alt="4" style="max-height: 10rem;"/>
        
        <h6 class="text-left">5 - Pronto seu id.</h6>
        <b-img class="shadow rounded" thumbnail v-viewer :src="require('@/assets/telegram/5.jpeg')" fluid alt="5" style="max-height: 10rem;"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<style>
  .textoFiltros {
    font-weight: bold;
    color: #2c3e50;
    left: 0;
    text-align: left;
    padding-top: 1.5vh;
  }
</style>
